// The Held Breath — a shared 0→1 factor. When it rises, the light field slows
// almost to stillness and dims, as if the void were holding its breath.
export const hush = { k: 0 };
